import { api } from "api/common";
import { createActionsHook } from "react-redux-actions-hook";
import { setToastMessage } from "../app/actions";
import {
  ALL_USERS,
  CREATE_INVITE_LINK,
  CREATE_USER,
  SEND_INVITE,
  USER_URL,
  BREAK_DOWN,
} from "../../api/constants";
import { UserActionType } from "components/User/constants";

// Common load data wrapper
export const loadUsers = (data = {}) => {
  return (dispatch, stateFn) => {
    const state = stateFn().user;
    api(
      `${ALL_USERS}`,
      {
        method: "POST",
        body: JSON.stringify({ ...state.table, ...data }),
      },
      dispatch
    )
      .then((response) => {
        dispatch(setUsersData(response.data));
        dispatch(loadBreakDown());
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const setUsersData = (members) => {
  return { type: UserActionType.SET_USERS, members };
};

export const setBreakDown = (breakDown) => {
  return { type: UserActionType.SET_BREAK_DOWN, breakDown };
};

export const setEditUser = (data) => {
  return { type: UserActionType.SET_USER_DATA, data };
};

export const closeEditDialog = () => {
  return { type: UserActionType.CLOSE_DIALOG };
};

export const openEditDialog = () => {
  return { type: UserActionType.OPEN_DIALOG };
};

export const closeCreateDialog = () => {
  return { type: UserActionType.CLOSE_CREATE_DIALOG };
};

export const openCreateDialog = () => {
  return { type: UserActionType.OPEN_CREATE_DIALOG };
};

export const setInviteType = (inviteType) => {
  return { type: UserActionType.SET_INVITE_TYPE, inviteType };
};

export const setInviteLink = (inviteLink) => {
  return { type: UserActionType.SET_INVITE_LINK, inviteLink };
};

export const setOrderBy = (orderBy) => {
  return { type: UserActionType.SET_ORDER_BY, orderBy };
};

export const setPagination = (paging) => {
  return { type: UserActionType.SET_PAGING_OPT, paging };
};

export const setFilter = (filters) => {
  return { type: UserActionType.SET_FILTER, filters };
};

export const setSearch = (search) => {
  return { type: UserActionType.SET_SEARCH_TEXT, search };
};

export const setPageOffset = (offset) => {
  return { type: UserActionType.SET_PAGE_OFFSET, offset };
};

export const setDeleteConfirmationVisibility = (isOpen) => {
  return { type: UserActionType.SET_CONFIRMATION_DIALOG, isOpen };
};

export const setCreateUser = (createUserDialog) => {
  return { type: UserActionType.SET_CREATE_USER, createUserDialog };
};

export const setTab = (selectedTab) => {
  return { type: UserActionType.SET_TAB, selectedTab };
};

export const deleteUser = (user_id) => {
  return (dispatch) => {
    api(`${USER_URL}/${user_id}`, { method: "DELETE" }, dispatch)
      .then(() => {
        dispatch(loadUsers());
        dispatch(
          setToastMessage({
            message: "Deleted user",
            type: "success",
          })
        );
      })
      .catch((error) => {
        //Handle Error
        dispatch(
          setToastMessage({
            message: error.message || "User Deletion Failed !",
            type: "error",
          })
        );
      });
  };
};

export const updateUser = (user_id, data, callback = () => {}) => {
  return (dispatch) => {
    api(
      `${USER_URL}/${user_id}`,
      { method: "PUT", body: JSON.stringify(data) },
      dispatch
    )
      .then(() => {
        dispatch(loadUsers());
        dispatch(
          setToastMessage({
            message: "User updated",
            type: "success",
          })
        );
        callback();
      })
      .catch((error) => {
        //Handle Error
        dispatch(
          setToastMessage({
            message: error.message || "Unable to update user",
            type: "error",
          })
        );
      });
  };
};

export const createUser = (data, callback = () => {}) => {
  return (dispatch) => {
    api(
      `${CREATE_USER}`,
      {
        method: "POST",
        body: JSON.stringify(data),
      },
      dispatch
    )
      .then(() => {
        dispatch(loadUsers());
        dispatch(
          setToastMessage({
            message: "Created user!",
            type: "success",
          })
        );
        callback();
      })
      .catch((error) => {
        //Handle Error
        dispatch(
          setToastMessage({
            message: error.message || "User Creation Failed!",
            type: "error",
          })
        );
      });
  };
};

export const sendInvite = (data, callback = () => {}) => {
  return (dispatch) => {
    api(
      `${SEND_INVITE}`,
      {
        method: "POST",
        body: JSON.stringify(data),
      },
      dispatch
    )
      .then((res) => {
        dispatch(
          setToastMessage({
            message: res.message || "Invitation Sent",
            type: "success",
          })
        );
        callback();
      })
      .catch((error) => {
        //Handle Error
        dispatch(
          setToastMessage({
            message: error.message || "Failed to send invite",
            type: "error",
          })
        );
      });
  };
};

export const generateInviteLink = (data) => {
  return (dispatch) => {
    api(
      `${CREATE_INVITE_LINK}`,
      {
        method: "POST",
        body: JSON.stringify(data),
      },
      dispatch
    )
      .then((res) => {
        dispatch(setInviteLink(res.data));
        dispatch(
          setToastMessage({
            message: res.message || "Invitation Sent",
            type: "success",
          })
        );
      })
      .catch((error) => {
        //Handle Error
        dispatch(setInviteLink(""));
        dispatch(
          setToastMessage({
            message: error.message || "Failed to generate invite",
            type: "error",
          })
        );
      });
  };
};

export const loadBreakDown = (data) => {
  return (dispatch) => {
    api(`${BREAK_DOWN}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(setBreakDown(response.data));
      })
      .catch((error) => {});
  };
};

export default createActionsHook({
  loadUsers,
  loadBreakDown,
  deleteUser,
  updateUser,
  createUser,
  sendInvite,
  setInviteLink,
  openEditDialog,
  closeEditDialog,
  closeCreateDialog,
  setDeleteConfirmationVisibility,
  openCreateDialog,
  generateInviteLink,
  setEditUser,
  setCreateUser,
  setInviteType,
  setOrderBy,
  setPagination,
  setFilter,
  setSearch,
  setPageOffset,
  setTab,
});
